export function filterEmptyProps<T>(element: KeyValue<unknown>): T {
  const init: KeyValue<unknown> = {};
  return Object.keys(element).reduce(function (r, e) {
    if (element[e as keyof typeof element] !== undefined)
      r[e as unknown as string] = element[e as keyof typeof element];
    return r;
  }, init) as unknown as T;
}

export function getStringFromObject(obj: KeyValue): string | undefined {
  try {
    return JSON.stringify(obj);
  } catch (err) {
    console.error(err);
  }
}
export const formatCount = (count: number, limit = 99): string => {
  return count > limit ? `${limit}+` : String(count);
};
export const findMatchedRoute = (pathname: string, routes: string[]): string | undefined => {
  return routes.find((route) => pathname.startsWith(route));
};

export function swap<T>(arr: T[], a: number, b: number): T[] {
  const newArr = [...arr];
  newArr[a] = newArr.splice(b, 1, newArr[a])[0];
  return newArr;
}

export function upsertImmutable<T extends Record<string, unknown>, K extends keyof T>(
  array: T[],
  newItem: T,
  key: K
): T[] {
  const exists = array.some((item) => item[key] === newItem[key]);
  if (exists) {
    return array.map((item) => (item[key] === newItem[key] ? newItem : item));
  } else {
    return [...array, newItem];
  }
}
